import React from 'react'
import './Logo.scss'

const Logo = () => {
  return (
    <div className='b-logo'>
      <img src="/assets/logo1.png" alt="Logotipo MeetTalent"></img>
    </div>
  )
}

export default Logo